// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Dp8g","spinnerMessage":"Spinner_spinnerMessage__byEx8","small":"Spinner_small__aVswT Spinner_spinner__1Dp8g"};